import React from 'react';
import { Table, Input, Icon } from 'semantic-ui-react';
import { Link } from 'react-router';
import Moment from 'moment';
import { dateFormats } from '../../common/constants/dateFormats';
import styles from './SiteSearch.scss';
import { default as pt } from 'prop-types';
import { directToEditTemplate } from '../../routes/Templates/modules/templateChron';

const SiteSearchTable = ({
  directToEventDetails,
  directToPortalEventDetails,
  eventResults,
  templateResults,
  open,
  searchText,
  search,
  keyDown,
  handleClick,
  handleCancel,
}) => {
  return (
    <div className={`test-global-search-container ${styles['global-search']}`}>
      <div
        className={`test-global-search-input-div ${styles['global-search__input-container']}`}
      >
        <Input
          icon={
            <Icon
              name={`${searchText ? 'cancel' : 'search'}`}
              link
              onClick={handleCancel}
            />
          }
          type="text"
          name="test-global-search-input"
          className={styles['global-search__input']}
          value={searchText}
          onChange={search}
          placeholder="Lookup ID, Event Name..."
          onKeyDown={keyDown}
          onClick={handleClick}
        />
      </div>
      {(eventResults.length > 0 || templateResults.length > 0) && open ? (
        <div
          className={`test-global-search-results ${styles['global-search__results']}`}
        >
          <Table singleLine fixed compact>
            <Table.Header className="background-grey">
              <Table.Row>
                <Table.HeaderCell colSpan={4} className="background-grey">
                  <Icon name="calendar" /> Events
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body
              className={`test-events-results ${styles['container']}`}
            >
              {eventResults.slice(0, 10).map((result) => {
                return (
                  // For CMS Events there is no lookup id in the result
                  <Table.Row
                    key={result.lookupId ? result.lookupId : result.id}
                    className={`test-event-result ${styles['site-search-results']}`}
                  >
                    <Table.Cell
                      width={4}
                      className={`test-event-result-name ${styles['event-name-cell']}`}
                      key={result.EventName}
                    >
                      <Link
                        className="test-event-result-link"
                        onClick={() => {
                          result.aXSEvent
                            ? directToPortalEventDetails(
                                result.aXSEvent.eventId
                              )
                            : directToEventDetails(result.id);
                        }}
                        to={`/events/${result.id}${
                          result.aXSEvent
                            ? '/portal/' + result.aXSEvent.eventId
                            : ''
                        }`}
                      >
                        {result.eventName}
                      </Link>
                    </Table.Cell>
                    <Table.Cell
                      className="test-event-result-lookup"
                      width={4}
                      key={result.lookupId}
                    >
                      {result.lookupId}
                    </Table.Cell>
                    <Table.Cell
                      className="test-event-result-venue"
                      width={4}
                      key={result.venue}
                    >
                      {result.venue}
                    </Table.Cell>
                    <Table.Cell
                      className="test-event-result-date"
                      width={4}
                      // For CMS Events there is no startDate in the result
                      key={
                        result.startDate
                          ? result.startDate
                          : result.sortableDate
                      }
                    >
                      {Moment(result.startDate).format(
                        dateFormats.SHORT_MONTH_DAY_YEAR_DISPLAY
                      )}
                    </Table.Cell>
                  </Table.Row>
                );
              })}
            </Table.Body>
            {templateResults.length > 0 ? (
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan={4} className="background-grey">
                    <Icon name="file outline" /> Templates
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
            ) : null}
            <Table.Body
              className={`test-templates-results ${styles['container']}`}
            >
              {templateResults.slice(0, 10).map((result) => {
                return (
                  <Table.Row
                    className={`test-template-result ${styles['site-search-results']}`}
                    key={result.id}
                  >
                    <Table.Cell
                      colSpan={4}
                      onClick={() => directToEditTemplate(result.id)}
                      className={styles['event-name-cell']}
                    >
                      {result.name}
                    </Table.Cell>
                  </Table.Row>
                );
              })}
            </Table.Body>
          </Table>
        </div>
      ) : null}
    </div>
  );
};

SiteSearchTable.propTypes = {
  /**
   * Directs user to Event Details Page
   * @type {[func]}
   */
  directToEventDetails: pt.func.isRequired,
  /**
   * User input
   * @type {[string]}
   */
  searchText: pt.string,
  /**
   * Updates searchText
   * @type {[function]}
   */
  search: pt.func.isRequired,
  /**
   * If results are being displayed (there is input in the search bar)
   * @type {[bool]}
   */
  open: pt.bool.isRequired,
  /**
   * Capturing keypress events, to handle cases where we need to collapse the UI
   * @type {[function]}
   */
  keyDown: pt.func.isRequired,
  /**
   * Capturing onclick event, collapse the search table if user clicks outside the container
   * @type {[function]}
   */
  handleClick: pt.func.isRequired,
  /**
   * Capturing oncancel event, collapse the search table if user clicks on the x mark
   * @type {[function]}
   */
  handleCancel: pt.func.isRequired,
  directToPortalEventDetails: pt.func,
  eventResults: pt.array,
  templateResults: pt.array,
};

export default SiteSearchTable;



// WEBPACK FOOTER //
// ./src/components/SiteSearch/SiteSearchTable.js